import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBriefcase, FaSpinner, FaSearch, FaEye } from 'react-icons/fa';
import api from '../../services/api';
import './CareersList.css';

function CareersList() {
  const [careers, setCareers] = useState([]);
  const [filteredCareers, setFilteredCareers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchCareers();
  }, []);

  useEffect(() => {
    filterCareers();
  }, [searchTerm, careers]);

  const fetchCareers = async () => {
    try {
      const response = await api.get('/api/admin/careers');
      setCareers(response.data.careers || response.data || []);
      setFilteredCareers(response.data.careers || response.data || []);
    } catch (error) {
      console.error('Error fetching careers:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterCareers = () => {
    if (!searchTerm.trim()) {
      setFilteredCareers(careers);
      return;
    }

    const filtered = careers.filter((career) => {
      const search = searchTerm.toLowerCase();
      return (
        career.fullName?.toLowerCase().includes(search) ||
        career.email?.toLowerCase().includes(search) ||
        career.phone?.includes(search) ||
        career.position?.toLowerCase().includes(search) ||
        career.address?.toLowerCase().includes(search)
      );
    });

    setFilteredCareers(filtered);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      new: 'status-new',
      reviewing: 'status-reviewing',
      shortlisted: 'status-shortlisted',
      rejected: 'status-rejected',
      hired: 'status-hired'
    };
    return statusColors[status] || 'status-new';
  };

  if (loading) {
    return (
      <div className="careers-loading">
        <FaSpinner className="spinner" />
        <p>Loading career applications...</p>
      </div>
    );
  }

  return (
    <div className="careers-list-page">
      <div className="careers-header">
        <div className="careers-title">
          <FaBriefcase />
          <h2>Career Applications</h2>
          <span className="careers-count">({careers.length})</span>
        </div>

        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, email, position..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {filteredCareers.length === 0 ? (
        <div className="no-careers">
          <FaBriefcase />
          <p>{searchTerm ? 'No applications found matching your search' : 'No career applications yet'}</p>
        </div>
      ) : (
        <div className="careers-grid">
          {filteredCareers.map((career) => (
            <Link
              to={`/admin/dashboard/careers/${career._id}`}
              key={career._id}
              className="career-card"
            >
              <div className="career-card-header">
                <div className="career-avatar">
                  {career.fullName.charAt(0).toUpperCase()}
                </div>
                <div className="career-info">
                  <h3>{career.fullName}</h3>
                  <p className="career-date">{formatDate(career.createdAt)}</p>
                </div>
                <span className={`status-badge ${getStatusBadge(career.status)}`}>
                  {career.status}
                </span>
              </div>

              <div className="career-card-body">
                <h4 className="career-position">{career.position || 'Position not specified'}</h4>
                <p className="career-experience">Experience: {career.experience || 'Not specified'}</p>
              </div>

              <div className="career-card-footer">
                <div className="career-details">
                  <span className="career-email">{career.email}</span>
                  <span className="career-phone">{career.phone}</span>
                </div>
                <button className="view-btn">
                  <FaEye /> View
                </button>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default CareersList;


